/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { select } from '../../core/themev2';
import { Container, DropdownInput, FeatureLabel, OptionsContainer, Select } from './styles';

const CustomContainer = styled(Container)`
  > ${FeatureLabel} {
    height: 19px;
  }
`;

const PillIndicator = styled(Select)`
  padding-left: 20px;
  display: grid;
  place-items: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  pointer-events: none;
  touch-action: none;
  &:disabled {
    background: ${select('lightGray')};
    border-radius: 8px 0 0px 8px;
    color: black;
    font-weight: 500;
  }
`;

const PillInput = React.memo(
  React.forwardRef(({ label = '', pillId, pill, defaultPillValue, defaultInputValue, children, ...rest }, ref) => {
    const { onChangeInput = () => {}, inputProps = {}, inputId, maxInputLength = 12 } = rest;
    return (
      <CustomContainer>
        <FeatureLabel htmlFor={pillId}>{label}</FeatureLabel>
        <OptionsContainer>
          <PillIndicator id={pillId} name={pillId} ref={ref} defaultValue={defaultPillValue}>
            <option value={pill.value}>{pill.name}</option>
          </PillIndicator>
          <DropdownInput
            className={React.isValidElement(children) ? 'error' : ''}
            id={inputId}
            name={inputId}
            defaultValue={defaultInputValue}
            maxLength={maxInputLength}
            max={999999999}
            onChange={onChangeInput}
            ref={ref}
            {...inputProps}
          />
          {children}
        </OptionsContainer>
      </CustomContainer>
    );
  })
);

export { PillInput };
